import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Filter, Order, OrderType, Paginator, Search } from '@docpath/linces-angular-components/common';
import { Table, TableField, TableFieldBadge, TableFieldBadges, TableFieldLink, TableFieldText, TableRow } from '@docpath/webcomponents';
import { Constants } from 'src/app/constants/constants';
import { RoutingPath } from 'src/app/constants/routing-path';

import { Dge, DgeState } from '../../models/dge';
import { EnginesHttpService } from '../../services/engines-http.service';

@Injectable({
    providedIn: 'root'
})
export class EnginesTableService {

    private readonly i18nPrefix = 'engines-config.table';

    dgesLoaded: EventEmitter<Dge[]> = new EventEmitter();

    private currentPage: number;
    private elements: number;
    private currentSize: number;
    private dges: Dge[] = [];

    constructor(
        private readonly enginesHttpService: EnginesHttpService,
        private readonly router: Router
    ) {
        this.currentPage = 1;
        this.elements = 0;
        this.currentSize = 25;
    }

    initTable(): Table {

        const header = this.initTableHeader();
        const body = this.initTableBody([]);

        return new Table(header, body);

    }

    initTableHeader(): TableRow {

        return new TableRow(
            [
                new TableFieldText(`${this.i18nPrefix}.engine-name`, undefined, undefined, undefined, undefined, true),
                new TableFieldText(`${this.i18nPrefix}.url`, undefined, undefined, undefined, undefined, true),
                new TableFieldText(`${this.i18nPrefix}.status`, undefined, { style: 'text-align: center' }, undefined, undefined, true),
                new TableFieldText(`${this.i18nPrefix}.sinclair-index`, undefined, undefined, undefined, undefined, true)
            ]
        );

    }

    initTableBody(dges: Dge[]): TableRow[] {

        return dges.map(dge => {
            const fields: TableField[] = [], nameClickAction = () => this.redirectToStatisticsByDge(dge.id);

            fields.push(new TableFieldLink(dge.name, dge.name, undefined, nameClickAction, dge.dgeDescription));
            fields.push(new TableFieldText(dge.url, undefined, undefined));
            fields.push(new TableFieldBadges([
                new TableFieldBadge(dge.currentState, undefined, { cssClass: this.getStatusDge(dge.currentState) }, true)
            ], { style: 'text-align: center' }));
            fields.push(new TableFieldText(dge.alias, undefined, undefined));

            const tableRow = new TableRow(fields);
            tableRow.content = dge;

            return tableRow;
        });

    }

    private redirectToStatisticsByDge(dgeId: number) {
        this.router.navigate([RoutingPath.PATH_STATISTICS, dgeId]);
    }

    private getStatusDge(dgeState: string): string {

        switch (dgeState) {
            case DgeState.RUNNING: return 'bg-dpgreen';
            case DgeState.STOPPING: return 'bg-dpyellow';
            default: return 'bg-dpred';
        }

    }

    loadDges(filters: Filter[], page = this.currentPage, size = this.currentSize): void {

        this.currentPage = page;
        this.currentSize = size;

        const search = new Search(filters, [new Order(Constants.CONF_ENGINES_ENGINE_NAME, OrderType.Asc)], [], new Paginator(page - 1, this.currentSize, this.elements));

        this.enginesHttpService.getDges(search, (result, totalSize) => {
            this.elements = totalSize;
            this.dges = result as Dge[];
            this.dgesLoaded.emit(result);
        });

    }

    getCurrentPage(): number {
        return this.currentPage;
    }

    getElements(): number {
        return this.elements;
    }

    getDges(): Dge[] {
        return this.dges;
    }

    getSelectedDge(table: Table): Dge[] {
        return table.body.filter(row => row.selected).map(row => row.content);
    }

    getCurrentSize(): number {
        return this.currentSize;
    }

}